import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { EnvironmentConfig } from '../../../shared/interfaces/environment.interface';

@Injectable({
  providedIn: 'root',
})
export class SupportService {
  private readonly _baseUrl = this._env.environment.pureSpectrum.url;

  constructor(
    private _http: HttpClient,
    @Inject('ENV') private _env: EnvironmentConfig
  ) {}

  notifyNoFeasibility(
    projectId?: number,
    user?: string,
    criteria?: string,
    qualifications?: string,
    localization?: string
  ) {
    return this._http.post(`${this._baseUrl}/support/notify/feasibility`, {
      projectId: projectId,
      user: user,
      criteria,
      qualifications,
      localization,
    });
  }
}
